module.exports = __webpack_public_path__ + "img/background.8ab6155e.png";